import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
  map,
  filter,
} from 'ramda';
import Input from '../../common/Input';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import MultiSelect from '../../common/MultiSelect';
import fields from './fields';
import { processFields } from '../../utils/prePost';
import Breadcrumbs from '../../common/Breadcrumbs';
import { validateFields } from '../../utils/validate';
import '../../css/forms/default-forms.css';
import { fetchUsersByRoleId } from '../../api/users';
import { linkDataToFields } from '../../utils/fields';
import { fetchShopById, updateShopById, loadWorkersByShopId } from '../../api/shops';
import hasAccess from "../../helpers/permissionChecker";

export class EditShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
      fieldsSync: false,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.fetchDataRouteById = this.fetchDataRouteById.bind(this);
    this.convertArrForMultiselect = this.convertArrForMultiselect.bind(this);
    this.convertArrToSend = this.convertArrToSend.bind(this);
  }

  componentWillMount() {
    this.props.getOwners();
    this.props.getWorkers();
    this.fetchDataRouteById();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.fieldsSync === false) {
      const currentShop = path(['shops', 'shop'], this.props);

      if (currentShop) {
        const fields = linkDataToFields(currentShop, this.state.fields, {
          workers: function(field, data) {
            var arr = [];
            const workers = this.convertArrForMultiselect(data);
            if(workers){
              for (let key in workers) {
                let cVal = workers[key];

                  arr.push({
                    value: cVal.id,
                    checked: cVal.value ? cVal.value : false,
                    label: cVal.firstname + " " + cVal.lastname
                  });

              }
            }else {
              arr = this.getWorkersList();
            }
            return arr;
          }.bind(this)
        });
        this.setState({
          fields: fields,
          fieldsSync: true,
        })
      }
    }
  }

  convertArrForMultiselect(data) {
    const workerList = path(['users', 'roleList', 'worker'], this.props) || [];
    const workersNameArr = map(item => item.id, workerList);

    if(data.length > 0) {
      for (let item in data) {
        const index = workersNameArr.indexOf(data[item]);
        index >= 0 ? workerList[index].value = true : 0;
      }
    }

    return workerList;
  }

  convertArrToSend(data) {
    const selectedArr = filter(item => item.checked, data.workers);
    if (selectedArr.length > 0) {
      data.workers = map(item => item.value, selectedArr).join(',');
    }

    return data;
  }

  fetchDataRouteById() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.getDataById(id);
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);
      this.props.saveForm(
        path(['shops', 'shop', 'id'], this.props),
        this.convertArrToSend(data));
    }
    return false;
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  cancel() {
    this.props.goToShops();
  }

  parseList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          checked: false,
          label: arr[i].firstname + ' ' + arr[i].lastname,
        });
      }
    }

    return arrCustomers;
  }

  getOwnersList() {
    const ownerList = path(['users', 'roleList', 'admin'], this.props) || [];
    return this.parseList(ownerList);
  }

  getWorkersList() {
    const workerList = path(['users', 'roleList', 'worker'], this.props) || [];
    return this.parseList(workerList);
  }

  render() {
    const hasAccessForEdit = hasAccess({
      'permAreaKey': 'shops',
      'permTypeKey': 'edit',
      'idForCheckingAuthor': path(['shops', 'shop', 'created_by_id'], this.props)
    });
    const disableFieldForEdit = !hasAccessForEdit;
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
           { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
           { url: '/pages/shops', icon: 'shop', name: 'Shops' },
           { icon: 'edit', name: 'Edit Shop' },
          ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Edit Shop
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                {hasAccessForEdit &&
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
                }
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    field={this.state.fields['name']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <ReactSelectWrapper
                    options={this.getOwnersList()}
                    field={this.state.fields['owner']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                  <MultiSelect
                    options={this.state.fields.workers.value.length > 0 ? this.state.fields.workers.value : this.getWorkersList()}
                    field={this.state.fields['workers']}
                    onChange={this.changeFormValue}
                    disabled={disableFieldForEdit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToShops: () => {
      dispatch(push('/pages/shops'));
    },
    getDataById: (id) => {
      fetchShopById(id)(dispatch);
    },
    getOwners: () => {
      fetchUsersByRoleId(1, 'admin')(dispatch);
    },
    saveForm: (id, data) => {
      updateShopById(id, data)(dispatch);
    },
    getWorkers: () => {
      fetchUsersByRoleId(4, 'worker')(dispatch);
    },
    getWorkersByShopId: (id) => {
      loadWorkersByShopId(id)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditShop);



// WEBPACK FOOTER //
// ./src/containers/EditShop/index.js